import type { Store } from '@types'

type PostHistoryStore = Store & {
  setOBBScene?: () => void
}

type BumpRenderCounter = () => void

/** Sincroniza escena 3D, OBBs e invalidación tras undo/redo. */
export function runPostHistoryChange(
  get: () => PostHistoryStore,
  bumpRender: BumpRenderCounter,
): void {
  get().setOBBScene?.()
  bumpRender()

  try {
    const r3f =
      typeof window !== 'undefined'
        ? (window as Window & { r3f?: { invalidate?: () => void } }).r3f
        : undefined
    r3f?.invalidate?.()
    requestAnimationFrame(() => r3f?.invalidate?.())
    setTimeout(() => r3f?.invalidate?.(), 40)
  } catch {
    // noop
  }
}
